// import required libraries
import $ from 'jquery';

// import components that run on every page
import detailsDefaultBlock from './components/detailsDefaultBlock';
import flyOutCaptions from './components/flyOutCaptions';
import Header from "./components/header";
import renderVideoPlayer from "./actions/renderVideoPlayer";
import scaleUp from './animations/scaleUp';
import stickyDonateButton from './components/stickyDonateButton';

// Import actions
import accessibility from './actions/accessibility';
import renderTabsBlock from './actions/renderTabsBlock';
import renderPeopleBlock from './actions/renderPeopleBlock';
import testimonialSlider from './components/testimonialSlider';

// call functions
accessibility();
detailsDefaultBlock();

renderPeopleBlock();
testimonialSlider();
flyOutCaptions();
Header($);
renderVideoPlayer();
scaleUp();
stickyDonateButton();
renderTabsBlock($);